import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	recentlyViewedFilters: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.filters.recently-viewed-filters',
		defaultMessage: 'Recently Viewed Filters',
		description: 'Section title for recently viewed filters',
	},
});
